import { DescriptionList, Modal } from '@efast_public/fjd-component-library';
import { PaymentInformation } from './PaymentInformation';

interface PaymentModalModalProps {
  readonly onClose: () => void;
  readonly paymentInformation: PaymentInformation | null;
  readonly isOpen: boolean;
}

export function PaymentModal({
  onClose,
  paymentInformation,
  isOpen
}: PaymentModalModalProps) {
  return (
    <Modal
      appElement={document.querySelector('.fjd-base-layout') as HTMLElement}
      closeOnBackdropClick={false}
      open={isOpen}
      onClose={onClose}
      data-testid="payment-modal"
    >
      <Modal.Header id="PaymentModal-header">
        Zahlungsinformationen
      </Modal.Header>
      <Modal.Content>
        <DescriptionList>
          {paymentInformation?.values.map((item, index) => (
            <DescriptionList.Item
              key={index}
              description={item.value}
              title={item.label}
            />
          )) ?? <div />}
        </DescriptionList>
      </Modal.Content>
    </Modal>
  );
}

export default PaymentModal;
